import { topicItems } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">热门话题</h2>
          <p className="text-sm text-foreground-500">全网热议焦点，看看大家都在讨论什么</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
          {topicItems.map((topic) => (
            <a
              key={topic.name}
              href="#topics"
              className="flex flex-col items-center p-4 rounded-2xl bg-background-100 hover:bg-primary-50 border border-background-200 hover:border-primary-200 transition-all cursor-pointer group"
            >
              <span className="font-heading text-2xl mb-2">#</span>
              <h3 className="text-sm font-medium text-foreground-800 mb-2 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.name}
              </h3>
              <span className="text-xs text-foreground-400">
                <i className="ri-chat-3-line mr-1"></i>{topic.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}